import { DialogActions } from 'ui-kit';
import { Dialog, DialogProps, Button } from 'ui-kit/index';

export interface ConfirmDialogProps {
  dialog: DialogProps;
  message: string;
  confirmButtonText: string;
  onConfirm: () => void;
  image?: string;
  imageW?: string;
  imageH?: string;
  imageAlt?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  dialog,
  message,
  onConfirm,
  confirmButtonText,
  image,
  imageW,
  imageH,
  imageAlt = '',
}) => {
  return (
    <Dialog dialog={dialog}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {image && <img src={image} alt={imageAlt} width={imageW} height={imageH} />}
        {/* Cap the width so long confirmation copy wraps instead of stretching the dialog across the screen. */}
        <div className={`max-w-sm text-center ${image ? 'mt-[20px]' : ''}`}>{message}</div>
      </div>
      <DialogActions>
        <Button
          type="secondary_light"
          label="Cancel"
          size="medium"
          onClick={() => dialog.setIsOpen(false)}
        >
          Cancel
        </Button>
        <Button
          label={confirmButtonText}
          size="medium"
          onClick={() => {
            onConfirm();
            dialog.setIsOpen(false);
          }}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
